import { render, staticRenderFns } from "./DocumentsPanel.vue?vue&type=template&id=5f142e30&scoped=true"
import script from "./DocumentsPanel.vue?vue&type=script&lang=js"
export * from "./DocumentsPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPanel.vue?vue&type=style&index=0&id=5f142e30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f142e30",
  null
  
)

export default component.exports